module.exports = __webpack_public_path__ + "02_medium_black.0f5405f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_medium_black.png
// module id = E+KD
// module chunks = 0